import React from 'react';
import './Field.css';
import 'emoji-mart/css/emoji-mart.css';
import EmojiPicker from './EmojiPicker';
import Axios from 'axios';
import authClient from '../auth/Auth';
import { urlRegex, API } from '../constants/constants';
import UploadedImages from './UploadedImages';

//Material UI
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';

export default function Field(props) {
    const [value, setValue] = React.useState(props.vlaue ? props.value : "");
    const [errorHidden, setErrorHidden] = React.useState(props.required ? false : true);
    const [isLoading, setLoading] = React.useState(false);
    const valueRef = React.useRef(value);
    valueRef.current = value;

    function pickedEmoji(emoji) {
        updateValue(`${value}${emoji.native}`);
    }

    function onChange(inputVal) {
        if (props.data_validate && inputVal) {
            const reg = new RegExp(props.data_validate);
            if (reg.test(inputVal)) {
                updateValue(inputVal);
            } else {
                updateValue(value);
            }
        } else {
            updateValue(inputVal);
        }
    }

    function handleRemoval() {
        if (props.removeCallback) {
            props.removeCallback(props.name);
        }
    }

    function shouldErrorBeDisplayed(val) {
        if (val && val.length > 0) {
            if (props.isUrl) {
                return !urlRegex(val);
            } else {
                return false;
            }
        } else {
            return props.required;
        }
    }

    function checkUpload() {
        Axios.get(valueRef.current)
            .then(res => {
                updateValue(valueRef.current);
            }).catch(err => {
                setTimeout(() => {
                    checkUpload();
                }, 30000);
            })
            .then(() => {
            });
    }

    function handleUpload(files) {
        console.log(files);
        if (files === null || files.length === 0) {
            return;
        }

        setLoading(true);
        Axios.post(

            props.isStaging ? API.staging.imageUpload : API.production.imageUpload,
            files[0],
            {
                headers: {
                    'Content-Type': files[0].type,
                    'x-access-token': authClient.getIdToken()
                }
            }
        ).then(response => {
            console.log(response.data);
            if (response && response.data && response.data.data) {
                updateValue(response.data.data.imageUrl);
                alert("Image uploaded successfully, it will be available within ~30 seconds");
                checkUpload();
            } else {
                alert("Unknown error");
            }
        })
            .catch(function (error) {
                console.log(error);
                alert(error);
            })
            .then(function () {
                // always executed
                console.log("call finished");
                setLoading(false);
            });
    }

    function selectedImage(image) {
        updateValue(image);
    }

    function updateValue(inputVal) {
        setValue(inputVal);
        setErrorHidden(!shouldErrorBeDisplayed(inputVal));
        if (props.listener) {
            props.listener(props.name, { value: inputVal, error: !errorHidden, root: props.root });
        }
    }

    return (
        <div className="Field">
            {props.removeCallback ? <Button variant="contained" className="Field-button" onClick={handleRemoval}>X</Button> : ""}
            <span className="Field-title">{props.title}</span>
            <input className="Field-input"
                id={props.id}
                type="text"
                name={props.name}
                placeholder={props.placeholder}
                value={value}
                onChange={e => onChange(e.target.value)}
            />
            {isLoading ? <LinearProgress /> : null}

            {props.emoji &&
                <EmojiPicker title="Pick Your Emoji!" onPickEmoji={pickedEmoji} />
            }
            {props.upload && [
                <UploadedImages
                    isStaging={props.isStaging}
                    selectedImage={selectedImage}
                />,
                <input type="file" accept=".png,.jpg,.jpeg" onChange={(e) => handleUpload(e.target.files)} />]
            }

            {!errorHidden &&
                <span className="Field-error" id={"error" + props.id}>
                    {props.error_msg}
                </span>}
        </div>
    );
}